import { render, staticRenderFns } from "./DocumentsHRM.vue?vue&type=template&id=34238281&"
import script from "./DocumentsHRM.vue?vue&type=script&lang=js&"
export * from "./DocumentsHRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports